import React from "react";

/**
 * Returns a debounced version of the provided callback function.
 * The debounced function will wait for the specified timeout before invoking the callback.
 *
 * @param {number} timeout - The timeout duration in milliseconds.
 * @param {Function} callback - The callback function to be debounced.
 * @returns {Function} - The debounced version of the callback function.
 */
export default function debounceFunction(timeout, callback) {
  const debounce = function (func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };

  return React.useCallback(debounce(callback, timeout), []);
}
